<template>
  <div class="report">
    <div class="top">
      <div class="right">
        <ul>
          <li :class="{ nav: nav == 0 }" @click="getBatch(0, 1)">本科提前批</li>
          <li :class="{ nav: nav == 1 }" @click="getBatch(1, 2)"> 高职高专提前批</li>
          <li :class="{ nav: nav == 2 }" @click="getBatch(2, 1)">本科普通批次</li>
          <li :class="{ nav: nav == 3 }" @click="getBatch(3, 2)">高职高专普通批</li>
        </ul>
      </div>
    </div>
    <div v-if="status">
      <div v-if="nav == 0 || nav == 1">
        <tiqianReport :batch_copy="batch_copy" :userInfo="userInfo"></tiqianReport>
      </div>
      <div v-if="nav == 2 || nav == 3">
        <putongReport :batch_copy="batch_copy" :userInfo="userInfo" :rankingData="rankingData"></putongReport>
      </div>
    </div>
  </div>
</template>

<script>
import tiqianReport from "./components/tiqianReport.vue";
import putongReport from "./components/putongReport.vue";
export default {
  name: '',
  props: ['new_batch', 'nav_act'],
  data() {
    return {
      nav: 3,
      batch_copy: 1,
      userInfo: {},
      rankingData: {
        ranking: 0,
        ranking_1: 0,
        ranking_2: 0,
        ranking_3: 0,
      },
      status: false
    };
  },
  components: {
    tiqianReport, putongReport
  },
  created() {
    this.nav = this.nav_act
    this.batch_copy = this.new_batch
    this.getUserInfo()
  },
  methods: {
    //获取用户信息
    getUserInfo() {
      //获取用户信息
      this.$fecth.post("user/getUserInfo", { id: this.$route.query.id }).then((res) => {
        let { code, msg, data } = res;
        if (code == 200) {
          this.userInfo = data
          this.getRanking()
        } else {
          this.showTips(0, msg);
        }
      });
    },

    //获取用户位次信息
    getRanking() {
      this.$fecth.post("user/getRanking", { subject: this.userInfo.subject, score: this.userInfo.score }).then((res) => {
        if (res.data) {
          this.rankingData = res.data
          this.status = true
        }
      });
    },
    showTips(flag, msg) {
      const title = flag == 1 ? "成功" : "失败";
      const type = flag == 1 ? "success" : "error";
      this.$notify({
        title: title,
        message: msg,
        type: type,
        duration: 2000,
      });
    },
    //选择批次
    getBatch(i, e) {
      this.nav = i
      this.batch_copy = e
    }
  },
};
</script>

<style scoped lang='less'>
.report {
  width: 1200px;
  margin: 0 auto;
  background: white;

  .score-table {
    font-size: 12px;
    color: #B5B3B3;
    border: 0;

    td {
      padding: 0;
      text-align: center;

    }
  }
}

.filter {
  padding: 0 52px;
  margin-top: 15px;
  height: 40px;

  ul {
    display: inline-block;
    list-style: none;
    position: relative;
    top: 7px;
  }

  li {
    float: left;
    width: 77px;
    text-align: center;
    margin-left: 13px;
    border: 1px solid #707070;
    border-radius: 19px;
    padding: 2px 5px;
  }

  li:hover {
    background: #459df6;
    color: white;
    border: #459df6;
  }



  .level {
    background: #459df6;
    color: white;
    border: #459df6;
  }
}

.top {
  margin-top: 20px;
  border-bottom: 4px solid #459EFF;
  height: 40px;
}

.right {
  float: right;
  height: 36px;

  ul {
    display: inline-block;
    list-style: none;
  }

  li {
    float: left;
    margin-left: 10px;
    height: 36px;
    padding: 17px;
    line-height: 3px;
    border-radius: 5px 5px 0 0;
  }

  li:hover {
    color: white;
    background: #459EFF;
    border-bottom: 1px solid #459EFF;
  }

}

.nav {
  color: white;
  background: #459EFF;
  border-bottom: 1px solid #459EFF;
}

.table {
  padding: 0 40px;
  margin: 0 auto;

  table {
    font-size: 14px;
    width: 100%;
    border-collapse: collapse;
    margin-top: 30px;
    border: 1px solid #dddddd;
    margin-bottom: 10px;

    .th {
      font-size: 16px;
      background: #f4f7fc;
      line-height: 35px;

      .name {
        font-size: 18px;
        font-weight: bold;
      }

      span {
        margin-right: 15px;
      }

      .col {
        margin-left: 0;
        color: #459df6;
      }
    }

    .th,
    td {
      line-height: 35px;
      padding: 5px 13px;
    }

    .td-height {
      .remarks {
        max-height: 40px;
        overflow: hidden;
      }
    }
  }

  .del {
    text-align: center;
    margin-bottom: 10px;
  }

  .huanwei {
    text-align: center;
    margin-bottom: 10px;
  }
}


.tab {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}





.px {
  margin-top: 20px;
  text-align: center;
  font-size: 14;
  margin-bottom: 10px;
}

.fc {
  text-align: center;
  color: #459df6;
  margin-bottom: 10px;
}
</style>


<style lang="less">
.mojarDialog {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>